module.exports = __webpack_public_path__ + "media/images/touch/splash-screen-712f0d223577530bc1de86ff747ff64e.png";